import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Divider, Icon, List, message, Modal, Typography, Upload } from "antd";
import { LoadingComponent } from "../../../../common/component/Index";
import Input from "../../../../common/component/Input";
import { capitalizeFirstLetter, checkUndefine } from "../../../../../../helpers/functions";
import './PromotionCodes.less';

const PromotionCodes = ({ ...props }) => {
    const { t } = useTranslation();
    const { onChange, parseExcel, promotionState, lstPromotionCodes, maxCodeCount, parseExcelClearData } = props;
    const { isFetchingParseExcel, promotionCodesDetail } = promotionState;
    const [visible, setVisible] = useState(false);
    const [promotionCodes, setPromotionCodes] = useState([]);
    const [promotionCodeInput, setPromotionCodeInput] = useState('');
    const [promotionCodesError, setPromotionCodesError] = useState({});

    useEffect(() => {
        if (promotionCodesDetail && promotionCodesDetail.data && promotionCodesDetail.errors) {
            setPromotionCodes([...promotionCodesDetail.data]);
            setPromotionCodesError({
                validationError: promotionCodesDetail.validationError,
                errors: promotionCodesDetail.errors,
            });
        }
    }, [promotionCodesDetail]);

    useEffect(() => {
        setPromotionCodes(lstPromotionCodes);
    }, [lstPromotionCodes]);

    const showModal = () => {
        setVisible(true);
    };

    const handleOk = () => {
        onChange && onChange('promotionCodes', promotionCodes);
        clearData();
    };

    const handleCancel = () => {
        setPromotionCodes(lstPromotionCodes);
        clearData();
    };

    const clearData = () => {
        setVisible(false);
        setPromotionCodeInput('');
        setPromotionCodesError({});
        parseExcelClearData && parseExcelClearData()
    }

    const onChangeValue = (e) => {
        setPromotionCodeInput(e.target.value);
    };

    const handleChange = (file) => {
        parseExcel && parseExcel(file.file)
    }

    const onRemovePromotionCodes = (item) => {
        if (item) {
            const oldPromotionCodes = promotionCodes;
            const newPromotionCodes = oldPromotionCodes.filter(eleItem => {
                return eleItem !== item;
            });
            setPromotionCodes([...newPromotionCodes]);
        }
    }

    const addPromotionCodeToList = () => {
        const oldPromotionCodes = [...promotionCodes];
        const inputPromotionCode = promotionCodeInput;
        const intMaxCodeCount = parseInt(maxCodeCount || 0)
        const trimValue = promotionCodeInput ? promotionCodeInput.trim() : promotionCodeInput;
        if (intMaxCodeCount > 0 && (trimValue.length >= 4 && trimValue.length <= 20) && (parseInt(oldPromotionCodes.length || 0) < intMaxCodeCount)) {
            const existedEmail = oldPromotionCodes.filter(item => {
                return item && inputPromotionCode && item.toLowerCase() === inputPromotionCode.toLowerCase();
            });
            if (existedEmail && existedEmail.length <= 0) {
                oldPromotionCodes.unshift(inputPromotionCode)
                setPromotionCodeInput('');
                setPromotionCodes([...oldPromotionCodes]);
            } else {
                message.warning({
                    content: t(`item.bundle.promotionCodeDuplicate`),
                });
            }
        } else {
            message.warning({
                content: t(`item.bundle.promotionCodeNotValid`),
            });
        }
    }

    return (
        <Fragment>
            <Button type="primary" onClick={ showModal } disabled={ parseInt(maxCodeCount || 0) <= 0 }>
                { lstPromotionCodes && lstPromotionCodes.length > 0 ? t(`item.bundle.selectedPromotionCode`).replace('{0}', lstPromotionCodes.length) : t(`item.bundle.selectPromotionCode`) }
            </Button>
            <Modal title={ t(`item.bundle.selectPromotionCode`) }
                   width={ 800 }
                   visible={ visible }
                   onOk={ handleOk }
                   onCancel={ handleCancel }
                   maskClosable={ false }
                   okButtonProps={{ disabled: isFetchingParseExcel }}
            >
                <LoadingComponent spinning={ isFetchingParseExcel }>
                    <div className="import-promotion-code-modal-container">
                        <div className="promotion-code-container">
                            <Input type={ `text` }
                                   className={ `form-control` }
                                   name={ `email` }
                                   value={ checkUndefine(promotionCodeInput) }
                                   autoComplete="off"
                                   onChange={ onChangeValue }
                                   onPressEnter={ addPromotionCodeToList }
                            />
                            <Button disabled={ promotionCodeInput === undefined || promotionCodeInput === '' }
                                    type="primary ml-2 same-height-with-textbox"
                                    onClick={ addPromotionCodeToList }
                            >{ t(`action.add`) }</Button>
                            <Upload
                                className="ml-2"
                                customRequest={ handleChange }
                                showUploadList={ false }
                                action=""
                            >
                                <Button className="same-height-with-textbox">
                                    <Icon type="upload"/>
                                </Button>
                            </Upload>
                        </div>
                        <Divider orientation={ "left" }/>
                        <div className={ promotionCodesError && promotionCodesError.errors ? 'promotion-code-list-container' : 'promotion-code-list-container-without-error' }>
                            <List
                                size="small"
                                bordered
                                dataSource={ promotionCodes }
                                renderItem={ item => (
                                    <List.Item
                                        actions={ [
                                            <Icon type="close-circle" className="fs18 cursorPointer" onClick={ () => onRemovePromotionCodes(item) }/>
                                        ] }
                                    >{ item }</List.Item>
                                ) }
                            />
                        </div>
                        {
                            promotionCodesError && promotionCodesError.validationError && promotionCodesError.errors && promotionCodesError.errors.length > 0 &&
                            <div className="promotion-code-error-contain">
                                <div className={ `import-faild-title` }><h3>{ capitalizeFirstLetter(t('item.bundle.importFailed')) } </h3></div>
                                <div>{ capitalizeFirstLetter(t('item.bundle.totalRowInFile')) } { promotionCodesError.validationError.totalCount }</div>
                                <div>{ capitalizeFirstLetter(t('item.bundle.totalRowValid')) } { promotionCodesError.validationError.successCount }</div>
                                <div>{ capitalizeFirstLetter(t('item.bundle.totalRowInvalid')) } { promotionCodesError.validationError.errorCount }</div>
                                <div className="promotion-code-list-error-container">
                                    <List
                                        size="small"
                                        bordered
                                        dataSource={ promotionCodesError && promotionCodesError.errors }
                                        renderItem={ item => (
                                            <List.Item>
                                                <Typography.Text mark>[{ t(`item.bundle.importFailedRow`) } { item.row }]
                                                    [{ t(`item.bundle.importFailedError`) } { item.error }]</Typography.Text> { item.data }
                                            </List.Item>
                                        ) }
                                    />
                                </div>
                            </div>
                        }
                    </div>
                </LoadingComponent>
            </Modal>
        </Fragment>
    )
}

export default PromotionCodes;
